import React from 'react';
import { initial, last } from 'lodash';
import { connect } from 'react-redux';
import { Wizard, Step } from '@fiverr-private/wizard_steps/src';
import PropTypes from 'prop-types';
import PreRevisionQuestionOnDelivery from '../PreRevisionQuestionOnDelivery';
import PreRevisionRejectionReasons from '../PreRevisionRejectionReasons';
import PreRevisionRejectionResolution from '../PreRevisionRejectionResolution';
import {
    setWithRevisionSettings,
    setWithPreRevisionSettings
} from '../../actions/settings';
import {
    QUESTION_STEP, REJECTION_REASONS_STEP,
    PARTIAL_DELIVERY_RESOLUTION_STEP, DISSATISFIED_QUALITY_STEP,
    RECEIVED_NOTHING_STEP,
    NEED_REVISIONS_STEP
} from './const';
import './style.scss';

const REJECTION_RESOLUTION_STEPS = [
    PARTIAL_DELIVERY_RESOLUTION_STEP,
    DISSATISFIED_QUALITY_STEP,
    RECEIVED_NOTHING_STEP
];

class PreRevisionWizard extends React.Component {
    state = {
        step: QUESTION_STEP
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { setWithRevisionSettings, setWithPreRevisionSettings } = this.props;
        this.syncHistory(prevProps, prevState);

        if (this.isWizrdEnded()) {
            setWithRevisionSettings(true);
            setWithPreRevisionSettings(false);
        }
    };

    syncHistory = (prevProps, prevState) => {
        if (
            this.state.step !== prevState.step &&
            last(this.history) !== this.state.step
        ) {
            this.history.push(this.state.step);
        }
    };

    history = [this.state.step];

    goBack = () => {
        const prevSteps = initial(this.history);
        const lastPrevStep = last(prevSteps);
        this.history = prevSteps;
        this.setStep(lastPrevStep);
    };

    isWizrdEnded = () => {
        const { step } = this.state;
        return !step || step === NEED_REVISIONS_STEP;
    };

    setStep = (step) => this.setState({ step });

    render() {
        const { step } = this.state;

        if (this.isWizrdEnded()) {
            return null;
        }

        return (
            <div className="pre-revision-wizard">
                <Wizard currentStepId={step}>
                    <Step id={QUESTION_STEP}>
                        <PreRevisionQuestionOnDelivery onDeliveryRejection={this.setStep}/>
                    </Step>
                    <Step id={REJECTION_REASONS_STEP}>
                        <PreRevisionRejectionReasons onReasonSelect={this.setStep} goBack={this.goBack}/>
                    </Step>
                    {REJECTION_RESOLUTION_STEPS.map((step) => (
                        <Step id={step} key={step}>
                            <PreRevisionRejectionResolution step={step} setStep={this.setStep} goBack={this.goBack}/>
                        </Step>
                    ))}
                </Wizard>
            </div>
        );
    }
}

PreRevisionWizard.propTypes = {
    setWithRevisionSettings: PropTypes.func.isRequired,
    setWithPreRevisionSettings: PropTypes.func.isRequired
};

export default connect(null, {
    setWithRevisionSettings,
    setWithPreRevisionSettings
})(PreRevisionWizard);
